import required from "./required";
import size from "./size";

export default {
  required,
  size
};
